
import greek from "greek-utils";
export default {
  props: ["display","hide"],
  name: "itemsHeader",
  data() {
    return {
      extraTab: "",
      extraSearch: "",
      hasData: false,
    };
  },
  methods: {
    async selectFilter(ba, sfilter) {
      if (sfilter == "sorting") {
        await this.$store.dispatch("syncSearch", { ba, sfilter });
      } else {
        await this.$store.dispatch("syncSearch", { ba, sfilter, init: true });
      }
      await this.$store.dispatch("doSearch");
      // await this.$store.dispatch("getAutoCompletes", {
      //   merge: true,
      //   properties: "manufacturer,tags",
      // });
      window.scrollTo(0, 0);
    },
    regTest(extraSearch, dd) {
      let reg = new RegExp(
        greek.toGreek(greek.sanitizeDiacritics(greek.toGreek(extraSearch))),
        "gi"
      );
      return reg.test(
        greek.toGreek(greek.sanitizeDiacritics(greek.toGreek(dd)))
      );
    },
    checkData() {
      let has = false;
      let keys = Object.keys(this.distinct).filter(
        (f) => f != "labels" && f != "icons"
      );
      keys.forEach((k) => {
        if (this.distinct[k].length) {
          has = true;
        }
      });
      return has;
    },
  },
  computed: {
    distinct() {
      return this.$store.state.distinct;
    },
  },
};
